enum GlobalAttachmentDialogFields {
	FILE = 'file'
}

export default GlobalAttachmentDialogFields;